/**
 * @deprecated Prefer usePosBarcodeInput for POS sales (Android + idle timing).
 * Thin wrapper for legacy call sites.
 */
import { usePosBarcodeInput } from "./usePosBarcodeInput";

export const useBarcodeScanner = (options) => {
	const { getSearchInputProps, refocusSearch } = usePosBarcodeInput(options);
	return {
		onKeyDown: getSearchInputProps().onKeyDown,
		resetKeyTimes: () => {},
		refocusSearch,
		getSearchInputProps,
	};
};

export default useBarcodeScanner;
